import { ogUrl } from "@/lib/ogSections";

/**
 * Per-page social preview cards composed by `scripts/build-og-cards.py`.
 *
 * Every Solutions detail page, Industries detail page and Ask Arif article
 * gets its own topic-matched 1216x640 creative built on one shared design
 * system (ink scrim + gold eyebrow + serif headline + brand footer).
 *
 * Wiring is automatic: drop `{slug}.jpg` into the matching folder under
 * `src/assets/og-cards/` (or re-run the generator) and the route picks it up.
 */
function mapBySlug(mods: Record<string, { default: string }>): Record<string, string> {
  return Object.fromEntries(
    Object.entries(mods).map(([path, mod]) => {
      const name = path.split("/").pop() ?? "";
      return [name.replace(/\.(jpe?g|png|webp)$/i, ""), mod.default];
    }),
  );
}

export const SOLUTION_OG_CARDS = mapBySlug(
  import.meta.glob<{ default: string }>("@/assets/og-cards/solutions/*.{jpg,jpeg,png,webp}", {
    eager: true,
  }),
);

export const INDUSTRY_OG_CARDS = mapBySlug(
  import.meta.glob<{ default: string }>("@/assets/og-cards/industries/*.{jpg,jpeg,png,webp}", {
    eager: true,
  }),
);

export const ASK_ARIF_OG_CARDS = mapBySlug(
  import.meta.glob<{ default: string }>("@/assets/og-cards/ask-arif/*.{jpg,jpeg,png,webp}", {
    eager: true,
  }),
);

/** Absolute URL for a card, with a caller-supplied fallback (already relative). */
export function absoluteOg(card: string | undefined, fallbackRelative: string): string {
  return ogUrl(card ?? fallbackRelative);
}
